module.exports = __webpack_public_path__ + "img/k-skyblue-woman-front.d3953cc0.jpg";